import React, { useState, createContext, useCallback } from "react";
import axios from "axios";
import Cookies from "js-cookie";

export const TeamsContext = createContext();

axios.defaults.withCredentials = true;

export const TeamsContextProvider = ({ children }) => {
  const [teams, setTeams] = useState(null);
  const [team, setTeam] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  // const [isLoading, setIsLoading] = useState(true);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [isAddMoreStaffOpened, setIsAddMoreStaffOpened] = useState(false);
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [isChangeNameModalOpen, setIsChangeNameModalOpen] = useState(false);
  const [currentStage, setCurrentStage] = useState(1);
  const [createTeamInfo, setCreateTeamInfo] = useState({
    team_name: "",
    servers_ids: [],
  });
  const [teamToEdit, setTeamToEdit] = useState(null);
  const [teamSuccess, setTeamSuccess] = useState("");

  const handleModalClose = () => {
    setIsInviteModalOpen(false);
    setCreateTeamInfo({ team_name: "", servers_ids: [] });
    setCurrentStage(1);
  };

  const setSuccessFunc = (successMessage) => {
    setTeamSuccess(successMessage);

    setTimeout(() => {
      setTeamSuccess("");
    }, 5000);
  };

  const fetchTeams = useCallback(() => {
    const operatorId = Cookies.get("userId");
    if (!operatorId) {
      console.error('[TEAMS CONTEXT] No operatorId found in cookies');
      return;
    }
    
    axios
      .get(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") + "/teams/get-teams",
        {
          params: { operatorId },
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        }
      )
      .then((res) => {

        if (res.data.teams) {
          res.data.teams.forEach((team, index) => {
          });
        }

        setTeams(res.data.teams);
      }).catch((err) => {
        console.error('[TEAMS CONTEXT] Error fetching teams:', err);
        console.error(err);
      });
  }, []);

  const fetchTeam = useCallback((teamId) => {
    return axios
      .get(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") + `/teams/get-team/${teamId}`,
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        }
      )
      .then((res) => {
        setTeam(res.data.team);
        return res.data.team; // Return the team data
      })
      .catch((err) => console.error(err));
  }, []);

  const createTeam = (operatorId) => {
    axios
      .post(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") + "/teams/create-team",
        { ...createTeamInfo, operatorId },
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        }
      )
      .then((res) => {
        handleModalClose();
        setTeams(res.data.teams);
        setSuccessFunc("You’ve created a new team");
      })
      .catch((err) => {
        console.error('[TEAMS CONTEXT] Error creating team:', err);
        console.error(err);
      });
  };

  const deleteTeam = (id) => {
    axios
      .post(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") + "/teams/delete-team",
        { teamId: id },
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        }
      )
      .then((res) => {
        setIsDeleteModal(false);
        setTeamToEdit(null);
        setTeams(res.data.teams);
      })
      .catch((err) => console.error(err));
  };

  const renameTeam = (id, newTeamName) => {
    axios
      .post(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") + "/teams/rename-team",
        { teamId: id, newTeamName },
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        }
      )
      .then((res) => {
        setIsChangeNameModalOpen(false);
        setTeamToEdit(null);
        setTeams(res.data.teams);
        setSuccessFunc(`Your team name has been changed`);
      })
      .catch((err) => console.error(err));
  };

  const addTeamMembers = (id, newMembers) => {
    axios
      .post(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") + "/teams/add-new-team-members",
        { teamId: id, newMembers: newMembers.map((el) => el.id) },
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        }
      )
      .then((res) => {
        setIsAddMoreStaffOpened(false);
        setTeam(res.data.team);
        setSuccessFunc(
          `You've added ${newMembers.length} staff to ${res.data.team.team_name} Team`
        );
      })
      .catch((err) => console.error(err));
  };

  const removeTeamMember = (id, membersToDelete) => {
    axios
      .post(
        (process.env.REACT_APP_KNOWBIE_API_URL || "https://knowbie-back-dev-ff38cc203ae3.herokuapp.com") + "/teams/remove-team-members",
        { teamId: id, membersToDelete },
        {
          headers: { Authorization: `Bearer ${Cookies.get("token")}` },
        }
      )
      .then((res) => {
        setIsDeleteModal(false);
        setSelectedUsers([]);
        setTeam(res.data.team);
        setSuccessFunc(
          `You've deleted ${membersToDelete.length} staff from ${res.data.team.team_name} Team`
        );
      })
      .catch((err) => console.error(err));
  };

  const refreshTeams = useCallback(() => {
    fetchTeams();
  }, [fetchTeams]);

  return (
    <TeamsContext.Provider
      value={{
        teams,
        isInviteModalOpen,
        setIsInviteModalOpen,
        handleModalClose,
        currentStage,
        setCurrentStage,
        createTeamInfo,
        setCreateTeamInfo,
        createTeam,
        fetchTeams,
        isDeleteModal,
        setIsDeleteModal,
        teamToEdit,
        setTeamToEdit,
        deleteTeam,
        isChangeNameModalOpen,
        setIsChangeNameModalOpen,
        renameTeam,
        team,
        setTeam,
        fetchTeam,
        selectedUsers,
        setSelectedUsers,
        isAddMoreStaffOpened,
        setIsAddMoreStaffOpened,
        addTeamMembers,
        removeTeamMember,
        teamSuccess,
        setTeamSuccess,
        setSuccessFunc,
        refreshTeams,
      }}
    >
      {children}
    </TeamsContext.Provider>
  );
};
